/**
 * Nahraje soubor se styly podle aktualni platformy
 */
export class StylesLoader {
    public static init(): void {
        /*
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "CSS/TescoSW_";
        if (TescoSW.DeviceInfo.DeviceProperties.Android)
            link.href += "Android";
        else if (TescoSW.DeviceInfo.DeviceProperties.BlackBerry)
            link.href += "BlackBerry";
        else if (TescoSW.DeviceInfo.DeviceProperties.iOS)
            link.href += "iOS";
        else if (TescoSW.DeviceInfo.DeviceProperties.WP)
            link.href += "WP";
        else
            return;
        link.href += ".css";
        document.head.appendChild(link);
        logger.log("nahran CSS soubor s nasledujici cestou: " + link.href);
        */
    }
}
